import React, { useMemo } from 'react';
import './index.scss';
import { IMetricsCard } from '../../type';
import { reviewsFormat } from '@op/utils/value';
import useLanguage from '@op/hooks/useLanguage';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import classnames from 'classnames';
import BubbleCommon from '@op/components/BubbleCommon';
export default function MetricsCard(props: IMetricsCard) {
  const { classNames, data, tabItem } = props;

  const { formatMessage } = useLanguage();

  const { oldTime, newTime, oldValue, dodValue, title, formatValue, value, formatDate, isHourly, tips } =
    useMemo(() => {
      const { title, valueKey, formatValue = reviewsFormat, formatDate, isHourly, tips } = tabItem;
      const value = data?.[valueKey] || 0;
      const oldValue = data?.[`old_${valueKey}`] || 0;
      const dodValue = data?.[`${valueKey}_dod`] || 0;
      const { time: newTime, oldTime } = data || {};

      return {
        oldTime,
        newTime,
        oldValue,
        dodValue,
        title,
        formatValue,
        value,
        formatDate,
        isHourly,
        tips
      };
    }, [data, formatMessage]);

  return (
    <div
      className={classnames(classNames, 'dbo-realtime-opinion-metrics-card')}
    >
      {
        tips ? (
          <BubbleCommon tipsMap={tips} placement='top' showIcon={false}>
            <div className="title">{title}</div>
          </BubbleCommon>
        ) : (
          <div className="title">{title}</div>
        )
      }
      <div className="value">{formatValue(value)}</div>
      <RingRatioBubble
        otherInfo={
          <div className="item-title">{title}</div>
        }
        newTime={newTime}
        oldTime={oldTime}
        oldValue={oldValue}
        newValue={value}
        placement="top-start"
        formateValue={formatValue}
        formateDate={formatDate}
      >
        <>
          <span className="context-text">{isHourly ? formatMessage({ id: 'HoH' }) : formatMessage({ id: 'DoD' })}</span>
          <PercentageItem percentage={dodValue}></PercentageItem>
        </>
      </RingRatioBubble>
    </div>
  );
}
